import type { IGetEventsAggregatedResponseBody } from "~/feature/dashboard/types";
import type { IAggregatedEventListItem } from "~/types/aggregatedEventListItem";

export const transformGetEventsAggregatedResponse = (
  response: IGetEventsAggregatedResponseBody
): IGetEventsAggregatedResponseBody => {
  if (!response?.data) {
    return response;
  }

  const { page = 1, limit = 10, data } = response;

  const transformedData: IAggregatedEventListItem[] = data.map(
    (event, index) => ({
      ...event,
      order: (page - 1) * limit + index + 1,
    })
  );

  return {
    ...response,
    data: transformedData,
  };
};
